export default {
    // --------Transaction--------
    // transactionName: 'Transaction Name',
    // action: "Action",
    // transactionStatus: "Status",
    walletTransactions: 'Wallet Transactions',
    transactionId: "Transaction ID",
    transactionNo: "Transaction No",
    amount: "Amount",
    statusConfirmationInfo: 'Status Confirmation Info',
    transactionDate: 'Transaction Date',
    internalReferenceNo: 'Internal Reference No',
    internalRemark: 'Internal Remark',

    // --------Request--------
    newWalletRequest: 'New Wallet Request',
    updateWalletRequest: "Update Wallet Request",
    walletRequests: 'Wallet Requests',

    walletRequestConfirmation: 'Wallet Request Confirmation',
    detailsOfWalletRequest: 'Details of Wallet Request',
    actionType: 'Action Type',
    transactionAmount: 'Transaction Amount',
    referenceNo: 'Reference No',
    fromCustomer: 'From Customer',
    toCustomer: 'To Customer',
    availableWallet: 'Available Wallet',
    statusType: 'Status Type'

};